import { ThreadWelcome } from '@assistant-ui/react-ui';
import { Flex } from 'antd';
import PropTypes from 'prop-types';
import AgentEntryPanel from './AgentEntryPanel';

const AgentWelcome = ({ onEntryStart, organizationId }) => (
  <ThreadWelcome.Root>
    <Flex vertical gap="large">
      <ThreadWelcome.Center>
        <ThreadWelcome.Avatar />
        <ThreadWelcome.Message />
      </ThreadWelcome.Center>
      <AgentEntryPanel onEntryStart={onEntryStart} organizationId={organizationId} />
    </Flex>
  </ThreadWelcome.Root>
);

AgentWelcome.propTypes = {
  onEntryStart: PropTypes.func.isRequired,
  organizationId: PropTypes.string,
};

AgentWelcome.defaultProps = {
  organizationId: undefined,
};

export default AgentWelcome;
